<app-side-menu>
  <div class="accounts-receivable-container">
    <!-- Filtros -->
    <div class="filters-section">
      <div class="filters-row">
        <div class="filter-group">
          <label for="customerFilter" class="form-label">Filtrar por Cliente:</label>
          <select 
            id="customerFilter" 
            class="form-select" 
            [(ngModel)]="filters.selectedCustomerId"
            (change)="onCustomerFilterChange(filters.selectedCustomerId)">
            <option value="">Todos os clientes</option>
            <option *ngFor="let customer of customers" [value]="customer.id">
              {{ customer.name }}
            </option>
            <option *ngIf="customers.length === 0" disabled>Nenhum cliente encontrado</option>
          </select>
        </div>

        <div class="filter-group">
          <label for="statusFilter" class="form-label">Filtrar por Status:</label>
          <div class="input-group">
            <select 
              id="statusFilter" 
              class="form-select" 
              [(ngModel)]="filters.selectedStatus"
              (change)="onStatusFilterChange(filters.selectedStatus)"
              [disabled]="loadingStatuses">
              <option value="">Todos os status</option>
              <option *ngFor="let status of statusOptions" [value]="status.name">
                {{ status.name }}
              </option>
            </select>
            <span class="input-group-text" *ngIf="loadingStatuses">
              <i class="fas fa-spinner fa-spin"></i>
            </span>
          </div>
        </div>

        <div class="filter-group">
          <label for="categoryFilter" class="form-label">Filtrar por Categoria:</label>
          <select 
            id="categoryFilter" 
            class="form-select" 
            [(ngModel)]="filters.selectedCategory"
            (change)="onCategoryFilterChange(filters.selectedCategory)">
            <option value="">Todas as categorias</option>
            <option *ngFor="let category of categoryOptions" [value]="category">
              {{ category }}
            </option>
          </select>
        </div>

        <div class="filter-group">
          <label for="costCenterFilter" class="form-label">Filtrar por Centro de Custo:</label>
          <select 
            id="costCenterFilter" 
            class="form-select" 
            [(ngModel)]="filters.selectedCostCenterId"
            (change)="onCostCenterFilterChange(filters.selectedCostCenterId)">
            <option value="">Todos os centros</option>
            <option *ngFor="let cc of costCenters" [value]="cc.id">
              {{ cc.code }} — {{ cc.name }}
            </option>
            <option *ngIf="costCenters.length === 0" disabled>Nenhum centro de custo encontrado</option>
          </select>
        </div>
      </div>
      <div class="filters-row">
        <div class="filter-group">
          <label class="form-label">Faixa de Vencimento:</label>
          <div class="d-flex gap-2">
            <input type="date" class="form-control" [(ngModel)]="filters.dueStartDate" (change)="onDueRangeChange()"/>
            <span class="align-self-center">até</span>
            <input type="date" class="form-control" [(ngModel)]="filters.dueEndDate" (change)="onDueRangeChange()"/>
          </div>
        </div>
        <div class="filter-group">
          <label class="form-label">Faixa de Recebimento:</label>
          <div class="d-flex gap-2">
            <input type="date" class="form-control" [(ngModel)]="filters.receiptStartDate" (change)="onReceiptRangeChange()"/>
            <span class="align-self-center">até</span>
            <input type="date" class="form-control" [(ngModel)]="filters.receiptEndDate" (change)="onReceiptRangeChange()"/>
          </div>
        </div>

        <div class="filter-actions">
          <button 
            type="button" 
            class="btn btn-outline-secondary"
            (click)="clearFilters()">
            <i class="fas fa-times me-2"></i>
            Limpar Filtros
          </button>
        </div>
      </div>
    </div>

    <!-- Tabela de Contas a Receber -->
    <div *ngIf="!error">
      <app-table
        [title]="tableTitle"
        [columns]="columns"
        [data]="accountsReceivable"
        [loading]="loading"
        [showSearch]="showSearch"
        [searchPlaceholder]="searchPlaceholder"
        [clickable]="clickable"
        [actions]="actions"
        [disablePagination]="false"
        [totalItemsFromBackend]="totalItems"
        [currentPageFromBackend]="currentPage"
        [itemsPerPage]="pageSize"
        [totalPagesFromBackend]="totalPages"
        [hasNextPageFromBackend]="hasNextPage"
        [hasPreviousPageFromBackend]="hasPreviousPage"
        [enableSorting]="true"
        [clientSideSort]="true"
        [searchTerm]="filters.searchTerm"
        (actionClick)="onActionClick($event)"
        (searchChange)="onSearchChange($event)"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
        [searchPlaceholder]="'Buscar por documento, NF, SO ou descrição'">
        <app-button
          *appHasPermission="'AccountsReceivable.Create'"
          table-header-action
          text="Nova Conta a Receber"
          [color]="'var(--primary-light)'"
          [height]="'42px'"
          className="new-ar-btn"
          (buttonClick)="newAccountsReceivable()">
        </app-button>
      </app-table>
    </div>

    
<!-- Error Message -->
    <div *ngIf="error" class="alert alert-danger" role="alert">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <i class="fas fa-exclamation-triangle me-2"></i>
          {{ error }}
        </div>
        <button 
          type="button" 
          class="btn btn-outline-danger btn-sm"
          (click)="retryLoad()">
          <i class="fas fa-redo me-1"></i>
          Tentar Novamente
        </button>
      </div>
    </div>

  </div>
</app-side-menu>
